import Label from '@/app/common/components/Label'
import { RadioGroup, RadioGroupItem } from '@/shad/ui/radio-group'
import React from 'react'

type Props = {
  onChange: (value: string) => void
  value: string
  onBlur: React.FocusEventHandler<HTMLDivElement>
}

export default function ItemTypeSelector(props: Props) {
  const { onChange, value, onBlur } = props

  return (
    <div>
      <div className="mb-1">
        <Label>Item type</Label>
      </div>
      <RadioGroup
        onBlur={onBlur}
        onValueChange={onChange}
        defaultValue={value}
        className=""
      >
        <div className="flex items-center space-x-2 mt-1">
          <RadioGroupItem value="Service" id="service" />
          <Label weight={'normal'} htmlFor="service">
            Service
          </Label>
        </div>
        <div className="flex items-center space-x-2">
          <RadioGroupItem value="Good" id="good" />
          <Label weight={'normal'} htmlFor="good">
            Good
          </Label>
        </div>
      </RadioGroup>
    </div>
  )
}
